module.exports = __webpack_public_path__ + "fonts/Inter-900-cyrillic79.fdccea7.woff2";